module.exports = __webpack_public_path__ + "static/media/eef-x-bootcamp-logo.de5cf338.png";